export default {
  templates: state => state.newsletter.templates,
  templateInfos: state => state.newsletter.templateInfos,
  totalPages: state => state.totalPages
}
